const auxel = (props) => props.children;

export default auxel;


// WEBPACK FOOTER //
// ./src/hoc/Auxel/Auxel.js